import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { useT } from "../i18n";
import { CloseIcon } from "./icons";
import { LabelCell } from "./LabelCell";

interface LabelPreviewDialogProps {
  open: boolean;
  onClose: () => void;
  uuid: string;
  name: string;
}

/**
 * Full-size preview of a container's printed label — icons, QR, short UUID and
 * name (ADR-0027) — opened from the detail identity line so the label can be
 * held against the screen or the QR scanned from another device.
 */
export function LabelPreviewDialog({ open, onClose, uuid, name }: LabelPreviewDialogProps) {
  const t = useT();
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="label-preview-title" fullWidth maxWidth="xs">
      <DialogTitle
        id="label-preview-title"
        sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", py: 1.5 }}
      >
        {t("labelPreview")}
        <IconButton size="small" aria-label={t("close")} onClick={onClose}>
          <CloseIcon fontSize="inherit" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ display: "flex", justifyContent: "center" }}>
        <Box sx={{ width: "100%", maxWidth: 280 }}>
          <LabelCell uuid={uuid} name={name} />
        </Box>
      </DialogContent>
    </Dialog>
  );
}